// extracted by mini-css-extract-plugin
module.exports = {"OrderItem":"styles_OrderItem__Qb37J"};